import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import CrossIcon from '../icons/Cross';
import FiltersIcon from '../icons/Filters';
import PillButton from './Pill';

import styles from '../../../styles/buttons/filters-button.module.scss';

const propTypes = {
    opened: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

const defaultProps = {
    opened: false,
    className: null,
    onClick: null,
};

const FiltersButton = ({ opened, onClick, className }) => {
    const intl = useIntl();
    return (
        <PillButton
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            onClick={onClick}
            icon={opened ? <CrossIcon /> : <FiltersIcon />}
            title={
                opened
                    ? intl.formatMessage({
                          defaultMessage: 'Close filters',
                          description: 'Button label (a11y)',
                      })
                    : intl.formatMessage({
                          defaultMessage: 'Show search filters',
                          description: 'Button label (a11y)',
                      })
            }
        />
    );
};

FiltersButton.propTypes = propTypes;
FiltersButton.defaultProps = defaultProps;

export default FiltersButton;
